import React from "react";

/**
 * Fully flexible Button component
 * - Tailwind friendly
 * - Does NOT override user classes
 * - size / variant are OPTIONAL helpers
 */

const sizeClasses = {
  sm: "h-9 px-3 text-sm",
  md: "h-11 px-4 text-base",
  lg: "h-14 px-8 text-lg",
};

const variantClasses = {
  default: "bg-primary text-white hover:bg-primary/90",
  outline: "border border-white/20 bg-white/10 text-white hover:bg-white/20",
  ghost: "bg-transparent hover:bg-white/10",
};

export function Button({
  children,
  className = "",
  size,
  variant,
  disabled = false,
  type = "button",
  ...props
}) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`
        inline-flex items-center justify-center rounded-lg
        transition-all duration-200
        focus:outline-none focus:ring-2 focus:ring-ring
        ${size ? sizeClasses[size] || "" : ""}
        ${variant ? variantClasses[variant] || "" : ""}
        ${className}
        ${disabled ? "opacity-60 cursor-not-allowed" : ""}
      `}
      {...props}
    >
      {children}
    </button>
  );
}


export default Button;